import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-microsoft-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './microsoft-button.component.html',
  styleUrls: ['./microsoft-button.component.scss']
})
export class MicrosoftButtonComponent {
  @Input() disabled = false;
  @Input() text = 'Ingresa con Microsoft';
  @Output() click = new EventEmitter<void>();

  onButtonClick(): void {
    if (!this.disabled) {
      this.click.emit();
    }
  }
}